////  ESEMPIO CONVERSIONE ENUM
//option.key DocumentoInUscita
//IProtocol_Type[option.key] -> 1
//IProtocol_Type[IProtocol_Type[option.key]] -> DocumentoInUscita




export enum Protocol_State {
    Undefined = 0,
    InCreazione = 1,
    InCreazioneDaMail = 2,
    Allocato = 3,
    Prenotato = 4,
    Acquisito = 5,
    Protocollato = 6,
    Annullato = 7,
}

export enum Protocol_Type {
    Undefined = 0,
    DocumentoInEntrata = 1,
    DocumentoInUscita = 2,
    DocumentoInterno = 3
}
export enum AddEditUserAoo_Mode {
    Undefined = 0,
    AddUser = 1,
    EditUserOnly = 2,
    EditUserAndRole = 3
}
export enum ProtocolloAreaDiLavoroEF_Priority {
    Undefined = 0,
    Bassa = 1,
    Media = 2,
    Alta = 3
}
export const ProtocolloAreaDiLavoroEF_Priority_Label = new Map<number, string>([
    [ProtocolloAreaDiLavoroEF_Priority.Undefined, ''],
    [ProtocolloAreaDiLavoroEF_Priority.Bassa, 'Bassa'],
    [ProtocolloAreaDiLavoroEF_Priority.Media, 'Media'],
    [ProtocolloAreaDiLavoroEF_Priority.Alta, 'Alta']
]);

export enum ProtocolloAreaDiLavoroEF_State {
    Undefined = 0,
    DaLeggere = 1,
    InLavorazione = 2,
    Lavorato = 3
}
export const ProtocolloAreaDiLavoroEF_State_Label = new Map<number, string>([
    [ProtocolloAreaDiLavoroEF_State.Undefined, ''],
    [ProtocolloAreaDiLavoroEF_State.DaLeggere, 'Da leggere'],
    [ProtocolloAreaDiLavoroEF_State.InLavorazione, 'In lavorazione'],
    [ProtocolloAreaDiLavoroEF_State.Lavorato, 'Lavorato']
]);

export enum Protocol_ConfirmAction {
    Undefined = 0,
    CreaCanaleTeams,
    AcquisisciDocumento,
    ProtocollaDocumento,
    AnnullaProtocollo,
    ArchiviaProtocollo,
    EliminaBozza,
    EliminaAllegato

}

export enum ProtocolDispatchEF_Status {
    Undefined = 0,
    DaInviare = 1,
    Errore = 2,
    InAttesa = 3,
    NonAccettata = 4,
    CompletataConErrori = 5,
    Completata = 6
}
export const ProtocolDispatchEF_Status_Label = new Map<number, string>([
    [ProtocolDispatchEF_Status.Undefined, ''],
    [ProtocolDispatchEF_Status.DaInviare, 'Da inviare'],
    [ProtocolDispatchEF_Status.Errore, 'Errore'],
    [ProtocolDispatchEF_Status.InAttesa, 'In attesa'],
    [ProtocolDispatchEF_Status.NonAccettata, 'Non accettata'],
    [ProtocolDispatchEF_Status.CompletataConErrori, 'Completata con errori'],
    [ProtocolDispatchEF_Status.Completata, 'Completata']
]);

export enum ProtocolRegisterSP_Tipologia {
    Undefined = 0,
    Giornaliero = 1,
    Annuale = 2
}

export const ProtocolRegisterSP_Tipologia_Label = new Map<number, string>([
    [ProtocolRegisterSP_Tipologia.Undefined, ''],
    [ProtocolRegisterSP_Tipologia.Giornaliero, 'Giornaliero'],
    [ProtocolRegisterSP_Tipologia.Annuale, 'Annuale']
]);
export enum Visibility_Type {
    Undefined = 0,
    Proprietario = 1,
    Inoltro = 2,
    Visibilita = 3,
    CopiaConoscenza = 4
}
export const Visibility_Type_Label = new Map<number, string>([
    [Visibility_Type.Undefined, ''],
    [Visibility_Type.Proprietario, 'Proprietario'],
    [Visibility_Type.Inoltro, 'Inoltro'],
    [Visibility_Type.Visibilita, 'Visibilit�'],
    [Visibility_Type.CopiaConoscenza, 'Copia conoscenza']
]);



export enum LabelOrientation {
    Undefined = 0,
    Orizzontale = 1,
    Verticale = 2
}

export enum Indici_FormMode {
    Undefined = 0,
    Create = 1,
    Edit = 2,
    Search = 3,
    ReadOnly = 4,
    CreateForwardRule
}

export enum Visibilita_ViewMode {
    Undefined = 0,
    ActiveOnly = 1,
    Expanded = 2
}

export enum Search_QueryOperator {
    Undefined = 0,
    Equals = 1,
    Contains = 2
}


export enum Fascicolo_Type {
    Undefined = 0,
    Affare = 1,
    Attivita = 2,
    Procedimento = 3,
    PersonaFisica = 4,
    PersonaGiuridica = 5

}


export const Fascicolo_Type_Label = new Map<number, string>([
    [Fascicolo_Type.Undefined, ''],
    [Fascicolo_Type.Affare, 'Affare'],
    [Fascicolo_Type.Attivita, 'Attivit�'],
    [Fascicolo_Type.Procedimento, 'Procedimento'],
    [Fascicolo_Type.PersonaFisica, 'Persona fisica'],
    [Fascicolo_Type.PersonaGiuridica, 'Persona giuridica']
]);

export enum Wizard_Mode {
    Create,
    CreateFrom,
    PrintLabel,
    Edit,
    Reload,
    Acquired,
    Allocated
}

export const Wizard_Mode_Path = new Map<number, string>([
    [Wizard_Mode.Create, '/:aooId/new'],
    [Wizard_Mode.CreateFrom, '/:aooId/createfrom/:id'],
    [Wizard_Mode.Edit, '/:aooId/edit/:id'],
    [Wizard_Mode.Reload, '/:aooId/reload/:id'],
    [Wizard_Mode.Acquired, '/:aooId/acquired/:id/:protocolnumber'],
    [Wizard_Mode.Allocated, '/:aooId/allocated/:id/:protocolnumber'],
]);


export enum RoleContext {
    Undefined = 0,
    Aoo = 1,
    Uor = 2
}

export enum Search_Type {
    Tutto,
    Protocollo,
    Documenti
}
//export enum Search_Mode {
//    AllProtocols = 0, // restituisce tutti i protocolli che soddisfano i parametri di ricerca (per i protocolli sui quali non si hanno diritti � visibile solo il numero di protocollo )
//    BasedOnVisibility = 1 // restituisce tutti i protocolli che soddisfano i parametri di ricerca e i criteri di visibilit�
//}

export enum MailboxUor_Type {
    Udenfined = 0,
    In = 1,
    Out = 2
}

export enum RichiestaAnnullamento_Status {
    Undefined = 0,
    InCorso = 1,
    Annullata = 2,
    Rifiutata = 3,
    Approvata = 4
}

export const RichiestaAnnullamento_Status_Label = new Map<number, string>([
    [RichiestaAnnullamento_Status.Undefined, ''],
    [RichiestaAnnullamento_Status.InCorso, 'In Corso'],
    [RichiestaAnnullamento_Status.Annullata, 'Annullata'],
    [RichiestaAnnullamento_Status.Rifiutata, 'Rifiutata'],
    [RichiestaAnnullamento_Status.Approvata, 'Approvata']
]);


export enum Log_Operation {
    get_aoo,
    create_protocol,
    create_protocol_from_draft,
    create_protocol_draft,
    update_protocol_draft,
    delete_protocol_draft,
    reload_protocol,
    update_protocol,
    update_registered_protocol,
    register_protocol,
    undo_protocol,
    get_protocol,
    get_attach_protocol,
    get_file_protocol,
    get_audit_protocol,
    add_attachment,
    delete_attachment,
    get_user_active_aoo,
    get_features,
    get_feature,
    update_features,
    can_activate_feature,
    get_configurations,
    get_configuration,
    update_configurations,
    get_fields_by_view_name,
    get_fields_by_type,
    get_all_fields,
    get_lookup_suggestions,
    get_protocols_uor,
    get_protocols_as_stream,
    search_protocols,
    get_organization_chart,
    add_uor,
    get_users_uor,
    add_user_uor,
    update_user_uor,
    delete_user_uor,
    get_user_info,
    get_user_suggestions,
    add_user,
    get_roles,
    get_user_roles,
    get_filing_plan,
    add_filing_plan,
    get_forward_rules,
    get_forward_rule,
    create_forward_rule,
    update_forward_rule,
    delete_forward_rule,
    update_filing_plan_protocol,
    update_visibilita_protocol,
    get_uors_user_suggestions,
    get_user_visibilita_protocol,
    get_protocol_visibility,
    get_protocol_visibility_from_forward_rules,
    get_contacts_pecmail,
    send_mail_pecmail,
    get_sent_items_pecmail,
    get_ricevute_pecmail,
    get_mail_by_id_pecmail,
    get_mail_stati_ivio_pecmail,
    get_all_folders_pecmail,
    get_mails_in_folder_pecmail,
    get_base64_from_url_pecmail,
    get_pdf_corpo_mail,
    set_mail_registered_pecmail,
    send_notification,
    convert_file,
    delete_filing_plan,
    update_filing_plan,
    update_uor,
    delete_uor,
    updater,
    delete_user,
    update_user,
    get_all_user,
    add_user_sql_only,
    create_daily_protocol_register,
    create_annual_protocol_register,
    add_user_notifications,
    get_user_by_uor,
    update_user_notifications,
    delete_user_notifications,
    get_all_uors_for_currentuser_selected_aoo,
    get_user_uors_with_operator_role_selected_aoo,
    get_print_and_send_spedizioni,
    get_codici_lavorazione_print_and_send,
    add_print_and_send,
    get_print_and_send_stato_spedizione,
    update_print_and_send,
    get_exhibition_documents,
    exhibition_request,
    sign_document,
    get_protocol_references,
    create_protocol_reference,
    delete_protocol_reference,
    create_ricevuta_protocollazione,
    update_ricevuta_protocollazione,
    create_immediate_notification,
    update_immediate_notification,
    update_notification_queue,
    search_indice_pa,
    get_ente_pa,
    get_protocol_registers,
    get_protocol_register_file,
    get_versioni_docset,
    get_fascicoli,
    get_fascicolo,
    create_fascicolo,
    update_fascicolo,
    delete_fascicolo,
    close_fascicolo,
    open_fascicolo,
    get_protocolli_fascicolo,
    get_fascicoli_protocollo,
    add_protocol_to_fascicolo,
    remove_protocol_from_fascicolo,
    get_protocol_dispatches,
    get_protocol_dispatch,
    add_protocol_dispatches,
    update_protocol_dispatches,
    delete_protocol_dispatches,
    get_mailboxes,
    create_mailbox,
    delete_mailbox,
    update_mailbox,
    save_acquired_protocol,
    protocol_acquired_protocol,
    create_allocated_protocol,
    get_protocols_workspace,
    get_protocol_workspace,
    add_protocol_workspace,
    update_protocol_workspace,
    delete_protocol_workspace,
    start_processing_protocol_workspace,
    end_processing_protocol_workspace,
    reset_processing_protocol_workspace,
    assignment_protocol_workspace,
    get_users_aoo,
    add_user_aoo,
    update_user_aoo,
    delete_user_aoo,
    get_undo_request,
    add_undo_request,
    update_undo_request,
    approve_undo_request,
    reject_undo_request,
    annulla_undo_request,
    retry_incomplete_operations,
    get_signature_for_protocol,
    get_contact_suggestions,
    get_contact_info
}

export enum DocumentLoading_State {
    NoData = 0,
    Loading = 1,
    LoadSuccess = 2,
    LoadError = 3,
}

export enum DimensionFile_Unit {
    B = 0,
    KB = 1,
    MB = 2,
    GB = 3,
    TB = 4
}

export enum FilterEF_Operator {
    Equals,
    NotEquals,
    GreaterThan,
    GreaterEquals,
    LessThan,
    LessEquals,
    IsNull,
    IsNotNull,
    StartsWith,
    Contains,
    DateRanges
}

export enum SortEF_Direction {
    Undefined = 0,
    Ascending = 1,
    Descending = 2
}

